import { formatVisibility } from 'modules/dataDictionary/utils';
import { Hide16, View16 } from 'ui/icons';
import { Cell } from './Cell';

type VisibilityCellProps = {
  isHidden: boolean;
};

export const VisibilityCell = ({ isHidden }: VisibilityCellProps) => {
  const visibility = formatVisibility(!!isHidden);
  return <Cell data-justify="center">{visibility === 'hidden' ? <Hide16 /> : <View16 />}</Cell>;
};
